import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import Notiflix from "notiflix";

//ANT DESIGN IMPORTS
import { Row, Typography, Card, Spin, Form, Divider, Col, Collapse, Dropdown } from "antd";

//ANT DESIGN ICONS IMPORTS
import {
  SettingOutlined,
  DownloadOutlined,
  UploadOutlined,
  CalculatorOutlined,
  HolderOutlined,
  DoubleRightOutlined,
} from "@ant-design/icons";

//PROJECT IMPORTS
import TopContent from "../../../../components/layouts/TopContent";
import { BOM } from "../../../../services/definedMethod";
import cnt from "../../../../services/definedConstant";
import "../../../../assets/styles/DatePicker.css";
// import tabList from "./tabs/tabList.js";
import MainLayout from "../../../../components/layouts/MainLayout";
import { apiConfig, labelConfig, staticConfig } from "../../customer.config";
import Memo from "./tabs/Memo";
import Transactions from "./tabs/Transactions";
import Charges from "./tabs/Charges";
import { rightAction } from "../../../../redux/actions";
import {
  AccountFacility,
  handleFlgStatus,
  handleCurrentAccActionButtons,
  AmountFormat,
  accountStatus,
  handleFlgSubStatus,
  isDebit,
} from "../../../../components/facilities/AccountFacility";
import { Link } from "react-router-dom";
import ManageStandingInstructions from "./tabs/standingInstructions/ManageStandingInstructions";
import { showCheckerApprovalModal } from "../../../../components/CheckerModal";

const { Text, Title } = Typography;
const { Panel } = Collapse;

const CurrentAccountDetails = (props) => {
  //DECLARED VARIABLES
  const { userData, rightAction } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const { state } = useLocation();
  const [useForm] = Form.useForm();
  const [accountDetails, setAccountDetails] = useState([]);
  const [chargesList, setChargesList] = useState([]);
  const [transactionsList, setTransactionsList] = useState([]);
  const [memoList, setMemoList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [activeTabKey, setActiveTabKey] = useState("transactions");
  const [currentPage, setCurrentPage] = useState(1);
  const [tableCount, setTableCount] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [clientOfficeData, setClientOfficeData] = useState({
    officeId: "",
    officeName: "",
  });

  console.log(state);
  const [menuProps, setMenuProps] = useState({
    items: [],
  });
  const tabList = [
    {
      key: "transactions",
      label: "Transactions",
    },
    {
      key: "charges",
      label: "Charges",
      disabled: !BOM.HasPermission("READ_SAVINGSACCOUNTCHARGE"),
    },
    {
      key: "memo",
      label: "Memo",
      disabled: !BOM.HasPermission("READ_SAVINGNOTE"),
    },
    {
      key: "standingInstruction",
      label: "Standing Instructions",
      // disabled: !BOM.HasPermission("READ_SAVINGNOTE")
    },
  ];

  useEffect(() => {
    console.log(state);
    getClientById();
    // getDetailById();
    BOM.HasPermission("READ_SAVINGNOTE") && getNotes();
  }, []);

  const getClientById = () => {
    const url = `${apiConfig.Clients}/${state.clientId}`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
      } else {
        const objList = res;
        let temp = {
          officeId: objList.officeId,
          officeName: objList.officeName,
        };

        console.log(temp);

        setClientOfficeData(temp);

        getDetailById(temp, 0, Number(tableCount));
      }
    });
  };

  const getDetailById = (temp = clientOfficeData, offset = 0, _limit = Number(tableCount)) => {
    const params = {
      associations: "all",
      offset: offset,
      limit: _limit,
    };
    const url = `${apiConfig.savingsAccounts}/${state.id}`;

    let body = {
      session,
      params,
    };
    setIsLoading(true);

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        setAccountDetails(objDetail);
        setTotalItems(objDetail?.transactionSize);

        let tempInterestRateChartArray = [];
        let tempChargesArray = [];
        let tempTransactionsArray = [];

        objDetail?.accountChart?.chartSlabs?.forEach((element) => {
          tempInterestRateChartArray.push({
            key: element?.id,
            id: element?.id,
            periodType: element?.periodType ? element?.periodType?.value : "-",
            periodFromTo: `${element?.fromPeriod} - ${element?.toPeriod}`,
            amountRange: element?.amountRangeFrom ? element?.amountRangeFrom : "-",
            interest: element?.annualInterestRate ? element?.annualInterestRate : "-",
          });
        });

        objDetail?.charges?.forEach((element) => {
          tempChargesArray.push({
            key: element?.id,
            id: element?.id,
            name: element?.name ? BOM.SubstringFormat(element?.name, 20) : "-",
            penalty: element?.penalty ? "Penalty" : "Fee",
            paymentDueAt: element?.chargeTimeType?.value ? element?.chargeTimeType?.value : "-",
            dueAsOf: element?.dueDate ? BOM.DateTime(element?.dueDate, "only-date") : "-",
            repeatsOn: element?.feeOnMonthDay
              ? BOM.DateTimeWithoutYear(element?.feeOnMonthDay, "only-date")
              : "-",
            calculationType: element?.chargeCalculationType?.value
              ? element?.chargeCalculationType?.value
              : "-",
            due: element?.currency?.code
              ? `${element?.currency?.code} ${element?.amountOrPercentage}`
              : "-",
            paid: element?.currency?.code
              ? `${element?.currency?.code} ${element?.amountPaid}`
              : "-",
            waived: element?.currency?.code
              ? `${element?.currency?.code} ${element?.amountWaived}`
              : "-",
            outstanding: element?.currency?.code
              ? `${element?.currency?.code} ${element?.amountOutstanding}`
              : "-",
            status: handleFlgStatus(element?.isActive ? "active" : "closed", {}, true),
          });
        });

        objDetail?.transactions?.forEach((element) => {
          tempTransactionsArray.push({
            key: element?.id,
            id: element?.id,
            transactionDate: element?.date ? BOM.DateTime(element?.date, "only-date") : "-",
            transactionType: element?.transactionType ? element?.transactionType?.value : "-",
            debit: isDebit(element?.transactionType)
              ? Number(element?.amount).toLocaleString()
              : "-",
            credit: !isDebit(element?.transactionType)
              ? Number(element?.amount).toLocaleString()
              : "-",
            balance: element?.runningBalance
              ? `${element?.currency?.code} ${element?.runningBalance}`
              : "-",
          });
        });

        setChargesList(tempChargesArray);
        setTransactionsList(tempTransactionsArray);

        /**
         * ON CLICK ACTION MENU
         */
        setMenuProps({
          items: handleCurrentAccActionButtons(objDetail),
          onClick: (e) => {
            const item = handleCurrentAccActionButtons(objDetail).find(
              (element) => element.key === e.key
            );
            if (item) {
              switch (item?.label.toLowerCase()) {
                case "calculate interest":
                  return calculateInterest();
                case "post interest":
                  return postInterest();

                default:
                  //ROUTE REDIRECTING ACTIONS
                  return navigate(item.route, {
                    state: {
                      ...state,
                      accountNo: objDetail.accountNo,
                      actionLabel: item.label,
                      branchId: temp.officeId,
                    },
                  });
              }
            }
          },
        });
        /**
         * ACTIVATE DELETE RIGHT BUTTON ACTION
         */
        if (
          objDetail?.status?.value.toLowerCase() === accountStatus.submittedAndPending &&
          BOM.HasPermission("DELETE_SAVINGSACCOUNT")
        ) {
          rightAction(cnt.RIGHT_DELETE_BTN);
        }

        /**
         * STOP LOADER
         */
        setIsLoading(false);
      }
    });
  };

  const onRefresh = (offset = 0, limit = Number(tableCount)) => {
    getDetailById(clientOfficeData, offset, limit);
    setCurrentPage(1);
  };

  const getNotes = () => {
    setIsLoading(true);

    const url = `${apiConfig.Savings}/${state.id}/notes`;

    let body = {
      session,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        let tempMemoArray = [];

        objDetail?.forEach((element) => {
          tempMemoArray.push({
            key: element?.id,
            memoId: element?.id,
            createdBy: element?.createdByUsername ? element?.createdByUsername : "-",

            memo: element?.note ? element?.note : "-",
            createdOn: element?.createdOn ? BOM.DateTime(element?.createdOn, "only-date") : "-",
          });
        });
        setMemoList(tempMemoArray);

        setIsLoading(false);
      }
    });
  };

  const onTabChange = (key) => {
    setActiveTabKey(key);
  };
  const handleOnDelete = () => {
    let action = "Delete Account  ";
    let accountNo = accountDetails.accountNo;

    Notiflix.Confirm.show(
      "Are you sure?",
      action + accountNo,
      "Yes",
      "No",

      function () {
        setIsLoading(true);
        const url = `${apiConfig.savingsAccounts}/${state.id}`;
        let body = {
          session,
          method: "DELETE",
          session,
        };
        BOM.FetchReqAction(
          body,
          url,
          (err, res) => {
            if (err) {
              BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
              //STOP LOAD
              setIsLoading(false);
            } else {
              BOM.AlertMsg(cnt.SUCCESS, labelConfig.deleteCurrentAccountMsg);
              navigate("/acc0101");
              //STOP LOAD
              setIsLoading(false);
            }
          },
          {
            navigate,
            showCheckerModal: showCheckerApprovalModal,
            onCheckerApproval: (res) => {
              navigate("/detail-current-account", { state: { ...state } });
              setIsLoading(false);
            },
          }
        );
      },

      function () {
        // No button
      }
    );
  };

  function postInterest() {
    setIsLoading(true);
    const params = {
      command: "postInterest",
    };
    const url = `${apiConfig.savingsAccounts}/${state.id}`;

    let body = {
      session,
      params,
    };

    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.postInterestCurrentAccMsg);
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/detail-current-account", { state: { ...state } });
          setIsLoading(false);
        },
      }
    );
  }
  function calculateInterest() {
    setIsLoading(true);
    const params = {
      command: "calculateInterest",
    };
    const url = `${apiConfig.savingsAccounts}/${state.id}`;

    let body = {
      session,
      params,
    };

    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, labelConfig.calculateInterestCurrentAccMsg);
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          navigate("/detail-current-account", { state: { ...state } });
          setIsLoading(false);
        },
      }
    );
  }
  const contentListNoTitle = {
    transactions: (
      <Transactions
        currentPage={currentPage}
        tableCount={tableCount}
        totalItems={totalItems}
        setCurrentPage={setCurrentPage}
        onRefresh={onRefresh}
        transactionsList={transactionsList}
        userData={userData}
        state={state}
      />
    ),
    charges: (
      <Charges
        chargesList={chargesList}
        setChargesList={setChargesList}
        state={state}
        userData={userData}
        refreshDetail={getDetailById}
        refreshNote={getNotes}
      />
    ),
    memo: (
      <Memo
        memoList={memoList}
        useForm={useForm}
        state={state}
        userData={userData}
        setMemoList={setMemoList}
        getNotes={getNotes}
      />
    ),
    standingInstruction: (
      <ManageStandingInstructions
        useForm={useForm}
        state={state}
        userData={userData}
        clientOfficeData={clientOfficeData}
      />
    ),
  };

  return (
    <MainLayout isEnableRightSidebar={true} onDelete={handleOnDelete}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.detailCurrentAccount}
        pageItems={staticConfig.detailCurrentAccountBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form form={useForm} layout="vertical" style={{ paddingTop: 20, marginBottom: 50 }}>
            <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.generalInfo}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10 }} />
            <Row>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Dropdown.Button menu={menuProps} icon={<SettingOutlined />} placement="topLeft">
                  Actions
                </Dropdown.Button>
              </Col>

              <Col span={12} style={{ padding: "0px 8px" }}>
                <AccountFacility
                  accountName={accountDetails?.clientName}
                  productName={accountDetails?.savingsProductName}
                  accountNo={accountDetails?.accountNo}
                  status={accountDetails?.status}
                />
              </Col>
            </Row>

            <Row style={{ marginBottom: 30 }}>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Card
                  bordered={true}
                  bodyStyle={{
                    paddingTop: 17,
                    paddingBottom: 17,
                    paddingLeft: 24,
                  }}
                  hoverable={true}
                  style={{ marginBottom: 16 }}
                >
                  <AmountFormat
                    labelName={labelConfig.currentBalance}
                    currency={accountDetails?.currency?.code}
                    amount={accountDetails?.summary?.availableBalance}
                    precision={accountDetails?.summary?.currency?.decimalPlaces}
                  />
                </Card>
              </Col>

              <Col span={12} style={{ padding: "0px 8px" }}>
                <Card
                  bordered={true}
                  bodyStyle={{
                    paddingTop: 17,
                    paddingBottom: 17,
                    paddingLeft: 24,
                  }}
                  hoverable={true}
                  style={{ marginBottom: 16 }}
                >
                  <AmountFormat
                    labelName={labelConfig.availableBalance}
                    currency={accountDetails?.currency?.code}
                    amount={accountDetails?.summary?.availableBalance}
                    precision={accountDetails?.summary?.currency?.decimalPlaces}
                  />
                </Card>
              </Col>
            </Row>

            <Row>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <CurrentDetails accountDetails={accountDetails} />
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <PerformanceHistory accountDetails={accountDetails} />
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <InterestDetails accountDetails={accountDetails} />
              </Col>
            </Row>
          </Form>
        </Card>
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            width: "100%",
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
            marginTop: 24,
          }}
          tabList={tabList}
          activeTabKey={activeTabKey}
          onTabChange={onTabChange}
          tabProps={{
            size: "middle",
          }}
        >
          {contentListNoTitle[activeTabKey]}
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
const mapDispatchToProps = { rightAction };

export default connect(mapStateToProps, mapDispatchToProps)(CurrentAccountDetails);

function CurrentDetails(props) {
  const { accountDetails } = props;

  return (
    <Collapse
      style={{
        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
        marginBottom: 25,
      }}
    >
      <Panel
        header={
          <Title level={5} style={{ margin: 0 }}>
            {labelConfig.accountInfo}
          </Title>
        }
        key="1"
      >
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 15,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 15,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomLeftRadius: 0,
              }}
            >
              <Text strong>{labelConfig.activationDate}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {BOM.FormatArrayDate(accountDetails?.timeline?.activatedOnDate)}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.bban}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.externalId ? accountDetails?.externalId : " - "}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.depositIban}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.externalId ? accountDetails?.externalId : " - "}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.interestRate}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.interestRate ? accountDetails?.interestRate : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.currency}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.currency?.name
                  ? `${accountDetails?.currency?.name}(${accountDetails?.currency?.code})`
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.accountOfficer}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.fieldOfficerName ? accountDetails?.fieldOfficerName : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 15,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                borderTopLeftRadius: 0,
              }}
            >
              <Text strong>{labelConfig.status}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.currency?.name ? `${accountDetails?.status?.value}` : "0"}
              </Text>
            </Col>
          </Row>
        </div>
      </Panel>
    </Collapse>
  );
}

function PerformanceHistory(props) {
  const { accountDetails } = props;

  return (
    <Collapse
      style={{
        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
        marginBottom: 25,
      }}
    >
      <Panel
        header={
          <Title level={5} style={{ margin: 0 }}>
            {labelConfig.performanceHistory}
          </Title>
        }
        key="1"
      >
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 15,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 15,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomLeftRadius: 0,
              }}
            >
              <Text strong>{labelConfig.interestEarned}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.currency?.code ? accountDetails?.currency?.code : "-"}{" "}
                {accountDetails?.summary?.totalInterestEarned ||
                accountDetails?.summary?.totalInterestEarned === 0
                  ? accountDetails?.summary?.totalInterestEarned
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 15,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 15,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                borderTopLeftRadius: 0,
              }}
            >
              <Text strong>{labelConfig.totalDeposits}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                <Text style={{ color: "#b8b8b8" }}>
                  {accountDetails?.currency?.code ? accountDetails?.currency?.code : "-"}{" "}
                  {accountDetails?.summary?.totalDeposits ||
                  accountDetails?.summary?.totalDeposits === 0
                    ? accountDetails?.summary?.totalDeposits
                    : "-"}
                </Text>
              </Text>
            </Col>
          </Row>
        </div>
      </Panel>
    </Collapse>
  );
}

function InterestDetails(props) {
  const { accountDetails } = props;

  return (
    <Collapse
      style={{
        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
        marginBottom: 25,
      }}
    >
      <Panel
        header={
          <Title level={5} style={{ margin: 0 }}>
            {labelConfig.financialInformation}
          </Title>
        }
        key="1"
      >
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 15,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        ></div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.totalAnnualFees}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.currency?.code ? accountDetails?.currency?.code : "-"}{" "}
                {accountDetails?.summary?.totalAnnualFees ||
                accountDetails?.summary?.totalAnnualFees === 0
                  ? accountDetails?.summary?.totalAnnualFees
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.interestEarned}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.currency?.code ? accountDetails?.currency?.code : "-"}{" "}
                {accountDetails?.summary?.totalInterestEarned ||
                accountDetails?.summary?.totalInterestEarned === 0
                  ? accountDetails?.summary?.totalInterestEarned
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.interestPosted}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.currency?.code ? accountDetails?.currency?.code : "-"}{" "}
                {accountDetails?.summary?.totalInterestPosted ||
                accountDetails?.summary?.totalInterestPosted === 0
                  ? accountDetails?.summary?.totalInterestPosted
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.lienBlockedAmount}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.currency?.code ? accountDetails?.currency?.code : "-"}{" "}
                {accountDetails?.summary?.totalOverdraftInterestDerived ||
                accountDetails?.summary?.totalOverdraftInterestDerived === 0
                  ? accountDetails?.summary?.totalOverdraftInterestDerived
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.earnedInterestNotPosted}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.currency?.code ? accountDetails?.currency?.code : "-"}{" "}
                {accountDetails?.summary?.interestNotPosted ||
                accountDetails?.summary?.interestNotPosted === 0
                  ? accountDetails?.summary?.interestNotPosted
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.nominalInterestrate}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.nominalAnnualInterestRate ||
                accountDetails?.nominalAnnualInterestRate === 0
                  ? `${accountDetails?.nominalAnnualInterestRate}%`
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.interestCompoundingPeriod}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.interestCompoundingPeriodType?.value
                  ? accountDetails?.interestCompoundingPeriodType?.value
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.interestPostingPeriod}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.interestPostingPeriodType?.value
                  ? accountDetails?.interestPostingPeriodType?.value
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.interestCalculatedUsing}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.interestCalculationType?.value
                  ? accountDetails?.interestCalculationType?.value
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong># {labelConfig.daysInYear}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.interestCalculationDaysInYearType?.value
                  ? accountDetails?.interestCalculationDaysInYearType?.value
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.withdrawalFee}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.currency?.code ? accountDetails?.currency?.code : "-"}{" "}
                {accountDetails?.withdrawalFee?.amount || accountDetails?.withdrawalFee?.amount
                  ? accountDetails?.withdrawalFee?.amount
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.lastActiveTransactionDate}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.lastActiveTransactionDate
                  ? BOM.DateTime(accountDetails?.lastActiveTransactionDate, "only-date")
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.annualFee}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.currency?.code ? accountDetails?.currency?.code : "-"}{" "}
                {accountDetails?.annualFee?.amount || accountDetails?.annualFee?.amount === 0
                  ? accountDetails?.annualFee?.amount
                  : "-"}
                {" on "}
                {accountDetails?.annualFee?.dueDate
                  ? BOM.DateTimeWithoutYear(accountDetails?.annualFee?.dueDate, "only-date")
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.maxOverdraftLimit}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails.overdraftLimit || accountDetails.overdraftLimit === 0
                  ? accountDetails.overdraftLimit
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.enforceMinimumBalance}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails.enforceMinRequiredBalance ? "True" : "False"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.minimumBalance}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails.minRequiredBalance || accountDetails.minRequiredBalance
                  ? accountDetails.minRequiredBalance
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 15,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 15,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                borderTopLeftRadius: 0,
              }}
            >
              <Text strong>{labelConfig.interestRecalculationDate}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.summary?.lastInterestCalculationDate
                  ? BOM.DateTime(accountDetails?.summary?.lastInterestCalculationDate, "only-date")
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 15,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 15,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                borderTopLeftRadius: 0,
              }}
            >
              <Text strong>{labelConfig.subStatus}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.subStatus?.value
                  ? handleFlgSubStatus(accountDetails?.subStatus?.value)
                  : "-"}
                {/* {handleFlgSubStatus()} */}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 15,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 15,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                borderTopLeftRadius: 0,
              }}
            >
              <Text strong>{labelConfig.balanceOnHold}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              {accountDetails?.savingsAmountOnHold ? (
                <Link
                  to={"/current-account-action"}
                  state={{ actionLabel: "hold items", id: accountDetails.id }}
                  style={{ color: "#92428b", textDecoration: "underline" }}
                >
                  {accountDetails?.savingsAmountOnHold}
                </Link>
              ) : (
                <Text style={{ color: "#b8b8b8" }}>--</Text>
              )}
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 15,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 15,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                borderTopLeftRadius: 0,
              }}
            >
              <Text strong>{labelConfig.reasonForBlockHold}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.reasonForBlock ? accountDetails?.reasonForBlock : "--"}
              </Text>
            </Col>
          </Row>
        </div>
      </Panel>
    </Collapse>
  );
}
